var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-selector"},_vm._l((_vm.tree),function(item,idx){return _c('tree-item',{key:idx,attrs:{"item":item,"value":_vm.value,"is-filtered":_vm.isFiltered},on:{"select":_vm.onSelectItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }